import { Menu, Portal, Tabs } from '@chakra-ui/react'
import cn from 'clsx'
import { FC } from 'react'

import { Button } from '@/components/ui'

import {
	IPlatform,
	ISelectedPlatform,
	TPlatformValue
} from '@/types/uploadForm.interface'

interface ISourceTabsProps {
	selectedPlatform: TPlatformValue
	onPlatformChange: (source: TPlatformValue) => void
	isUploaded?: boolean
	formContent?: React.ReactNode
	platformList?: IPlatform[]
	selectedPlatformList?: ISelectedPlatform[]
	addPlatform?: (value: TPlatformValue) => void
}

export const SourceTabs: FC<ISourceTabsProps> = ({
	selectedPlatform,
	onPlatformChange,
	isUploaded,
	formContent,
	platformList,
	selectedPlatformList,
	addPlatform
}) => {
	const firstPlatform = selectedPlatformList?.[0]?.value

	const isMainFirstPlatform =
		firstPlatform === 'main-english' || firstPlatform === 'main-russian'

	const isIntFirstPlatform =
		firstPlatform === 'english' ||
		firstPlatform === 'spanish' ||
		firstPlatform === 'arabic'

	const availablePlatforms =
		platformList?.filter(({ value }) => {
			const isAlreadySelected = selectedPlatformList?.some(
				p => p.value === value
			)

			const isCurrentPlatformMain =
				value === 'main-english' || value === 'main-russian'

			return (
				!isAlreadySelected && !(isIntFirstPlatform && isCurrentPlatformMain)
			)
		}) ?? []

	return (
		<Tabs.Root
			unmountOnExit={false}
			value={selectedPlatform}
			onValueChange={details => {
				onPlatformChange(details.value as TPlatformValue)
			}}
			mb={8}
		>
			{!isUploaded && (
				<Tabs.List borderBottom='4px solid #E2E2E2' gap={0}>
					{(selectedPlatformList ?? []).map(p => {
						const label =
							platformList?.find(x => x.value === p.value)?.label ?? p.value

						return (
							// Tab's name
							<Tabs.Trigger
								key={p.value}
								value={p.value}
								className={cn(
									'px-4 py-4 justify-center text-[15px] font-[500] transition-colors before:h-[4px] before:bottom-[-4px]',
									selectedPlatform === p.value
										? 'text-gray-600 border-gray-600'
										: 'text-gray-400'
								)}
							>
								{label}
							</Tabs.Trigger>
						)
					})}
					<Menu.Root positioning={{ placement: 'bottom-start' }}>
						{availablePlatforms.length > 0 && !isMainFirstPlatform && (
							<Menu.Trigger asChild>
								<Button
									className='!text-gray-400 rounded-none hover:bg-gray-50'
									size='lg'
								>
									<span className='flex items-center gap-1'>
										+ Add Platform
									</span>
								</Button>
							</Menu.Trigger>
						)}
						<Portal>
							<Menu.Positioner className='ml-4'>
								<Menu.Content>
									{availablePlatforms.map(({ value, label }) => (
										<Menu.Item
											key={value}
											value={value}
											onClick={() => addPlatform(value)}
										>
											{label}
										</Menu.Item>
									))}
								</Menu.Content>
							</Menu.Positioner>
						</Portal>
					</Menu.Root>
				</Tabs.List>
			)}

			{(selectedPlatformList ?? []).map(p => (
				<Tabs.Content key={p.value} value={p.value} px={0} pt={6}>
					{formContent}
				</Tabs.Content>
			))}
		</Tabs.Root>
	)
}
